export class ValidationError extends Error {
  constructor(errors) {
    super("Validation error");

    this.response = {
      status: 400,
      data: errors
    };
  }
}
